import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const TAB_TO_PERMISSIONS = {
  contacts: ['contacts:read:own', 'contacts:read:any'],
  templates: ['templates:read:own', 'templates:read:any'],
  'template-images': ['template-images:read:own', 'template-images:read:any'],
  campaigns: ['campaigns:read:own', 'campaigns:read:any'],
  events: ['events:read:own', 'events:read:any'],
  analytics: ['analytics:read:own'],
  news: ['news:read'],
  careers: ['careers:read'],
  'team-members': ['team-members:read'],
  'signature-builder': ['signature-builder:use'],
  'video-backgrounds': ['video-backgrounds:use'],
  'rate-calculator': ['rate-calculator:use'],
  'manage-clients': ['rate-clients:read'],
  billing: ['billing:read'],
  admin: ['admin:users:read', 'admin:users:write']
};

const ProtectedRoute = ({ requiredTab, requiredPermission, children }) => {
  const { effectiveRole, hasPermission, hasAnyPermission } = useAuth();
  const navigate = useNavigate();
  const [isAllowed, setIsAllowed] = useState(null);

  useEffect(() => {
    checkPermission();
  }, [effectiveRole, requiredTab, requiredPermission]);

  const checkPermission = async () => {
    if (requiredPermission) {
      const allowed = hasPermission(requiredPermission);
      if (!allowed) {
        navigate('/', {
          state: {
            message: `Your role "${effectiveRole}" does not have permission to access this page`,
            type: 'error'
          }
        });
        return;
      }

      setIsAllowed(true);
      return;
    }

    const mappedPermissions = TAB_TO_PERMISSIONS[requiredTab] || [];
    const allowed = mappedPermissions.length === 0 || hasAnyPermission(mappedPermissions);

    if (!allowed) {
      navigate('/', {
        state: {
          message: `Your role "${effectiveRole}" does not have permission to access this page`,
          type: 'error'
        }
      });
      return;
    }

    setIsAllowed(true);
  };

  // Show loading while checking permissions
  if (isAllowed === null) {
    return <div className="container" style={{ padding: '40px', textAlign: 'center' }}>Loading...</div>;
  }

  // If we get here, user has permission
  return children;
};

export default ProtectedRoute;
